import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=2b74a8dc&scoped=true&"
import script from "./VendorDetails.vue?vue&type=script&lang=js&"
export * from "./VendorDetails.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetails.vue?vue&type=style&index=0&id=2b74a8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74a8dc",
  null
  
)

export default component.exports